import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const StoricoStipendiConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/storico_stipendi',
      component: FuseLoadable({
        loader: () => import('./StoricoStipendi')
      })
    }
  ]
}
